var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-empty-container",attrs:{"id":"breakdance-empty-container"}},[_c('div',{staticClass:"breakdance-empty-container__add-element",class:{
      'breakdance-empty-container__add-element--disabled': !_vm.canAddElement
    },on:{"click":_vm.openAddPanel}},[_c('Icon',{attrs:{"icon":"PlusIcon","size":"22"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }